import React from "react";
import HilightTable from "../../../../components/HilightTable";
import {Spinner} from "react-bootstrap";
import {withNamespaces} from "react-i18next";
import NotificationCategory from "../../_inc/Navbar/_components/NotificationCategory";
import DeviceInfoColumn from "../../../../components/DeviceInfoColumn";
import moment from "moment";

const NotificationTable = ({t, list, networkDevices}) => {

    const columns = [
        {
            Header: 'readed',
            headerClassName: "text-center",
            classNameRow: 'text-center',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <input type="checkbox" disabled checked={data.readDate !== null} />
                )
            }
        },
        {
            Header: 'category',
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <div>
                        <p><NotificationCategory category={data.category}/>{ data.category }</p>
                    </div>
                )
            }
        },
        {
            Header: 'device-network',
            Cell: (props) => {
                const data = props.row.original;

                if(data.networkDeviceId) {
                    const device = networkDevices?.find(x => x.id === data.networkDeviceId);
                    return (
                        <DeviceInfoColumn networkDevice={device}/>
                    )
                } else {
                    return t('none')
                }
            }
        },
        {
            Header: 'description',
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <div className="card">
                        <div className="card-body">
                            <h6>{t(data.text)}</h6>
                            <p>{t(data.description)}</p>
                            <p><small>{ moment(data.createDate).format("DD-MM-YYYY h:mm:ss") }</small></p>
                        </div>
                    </div>
                )
            }
        }
    ];

    const tableResult = (
        list ?
            list.length === 0 ? (
                <div className="text-center p-4">
                    <h3>{t('notification-no-content')}</h3>
                </div>
            ) : (
                <HilightTable
                    columns={columns}
                    data={list}
                />
            ) : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>
            )
    )

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            {tableResult}
        </div>
    )
}
export default withNamespaces()(NotificationTable);